import React from 'react';
import { DropdownDivider, DropdownItem } from '../../../../component/dropdown';
import { TextBlock } from '../../../../component/accounting/styles';
import { FilesDropdownContentProps } from '../../../../interfaces/ProjectInterface';

const FilesDropdownContent: React.FC<FilesDropdownContentProps> = React.memo(function FilesDropdownContent({
  onFileUpload,
  fileInputRef,
  openDocsModal,
  openWhiteboardModal,
  openFolderModal,
  openDriveModal,
  openDropboxModal,
  openOnedriveModal,
  openNotionModal,
  openFigmaModal,
  handleFileClick
}) {
  return (
    <>
      <DropdownItem
        iconName='updated-file-icon'
        iconSize={16}
        iconViewBox='0 0 18 18'
        label='Start a new doc'
        onClick={openDocsModal}
        iconTone='fill'
      />
      <DropdownItem
        iconName='white-board-icon'
        iconSize={16}
        label='Whiteboard'
        onClick={openWhiteboardModal}
        iconTone='fill'
      />
      <DropdownItem
        iconName='filescreen-dropdown-folder-icon'
        iconSize={16}
        label='Make a new folder'
        onClick={openFolderModal}
        iconTone='fill'
      />
      <>
        <DropdownItem
          iconName='upload-icon'
          iconSize={16}
          label='Upload files'
          iconTone='fill'
          onClick={handleFileClick}
        />

        <input
          id='upload'
          type='file'
          ref={fileInputRef}
          multiple
          hidden
          onChange={onFileUpload}
          aria-label='Upload file'
        />
      </>
      <DropdownDivider />
      <TextBlock>Or link to files from …</TextBlock>
      <DropdownItem iconName='google-drive-icon' iconSize={16} label='Google Drive' onClick={openDriveModal} />
      <DropdownItem
        iconName='dropbox-icon'
        iconSize={16}
        iconViewBox='0 0 18 18'
        label='Dropbox'
        onClick={openDropboxModal}
      />
      <DropdownItem
        iconName='onedrive-icon'
        iconSize={16}
        iconViewBox='0 0 18 18'
        label='Onedrive'
        onClick={openOnedriveModal}
      />
      <DropdownItem
        iconName='notion-icon'
        iconSize={16}
        iconViewBox='0 0 18 18'
        label='Notion'
        onClick={openNotionModal}
      />
      <DropdownItem iconName='filescreen-figma-icon' iconSize={16} label='Figma' onClick={openFigmaModal} />
    </>
  );
});

export default FilesDropdownContent;
